// Unpublished Work © 2022-2025 Deere & Company.

import React from 'react';
import {ErrorPage} from '@deere/cap-it-ui.component-library';
import {Button} from '@deere/fuel-react/Button';
import {APP_BASE_PATH} from '../../../literals/customer-routes';
import {FormattedMessage} from 'react-intl';
import {useHistory} from 'react-router-dom';

export const OktaAuthError = () => {
    const history = useHistory();

    return (<ErrorPage
        message={<FormattedMessage
            id='messages.OKTA_WARNING_MESSAGE'
        />}
    >
        <Button
            onClick={() => history.push(APP_BASE_PATH)}
            variant={'primary'}
        >
            <FormattedMessage
                id='labels.CONTINUE'
            />
        </Button>
    </ErrorPage>);
};
